import axios from "axios";
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import "../styling/login.css";
import "../styling/register.css";
import { useHistory } from "react-router-dom";
import NavBar from "../components/NavBar";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import larlogo from "../assets/logo-beta.png";
import img1 from "../assets/signup graphics/financial tracking.png";
import img2 from "../assets/signup graphics/expensetracker.png";
import img3 from "../assets/signup graphics/pricingdiscovery.png";
import img4 from "../assets/signup graphics/analyticsandoptimization.png";
import { ReactComponent as EyeIcon } from "../assets/eyeIcon.svg";
import { ReactComponent as EyeSlashIcon } from "../assets/eyeSlashFill.svg";
import AuthService from "../services/auth";
import { GoogleLogin } from "react-google-login";
import { BrowserView, MobileView } from "react-device-detect";
import { useSelector } from "react-redux";
import ReactGA from "react-ga";
import { InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import ReferFriendPop from "../components/ReferFriendPop";
import useMediaQuery from "@mui/material/useMediaQuery";

interface RegisterProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logoBox: {
      display: "flex",
      // justifyContent: "center",
      margin: "10px",
      marginTop: "30px",
      marginRight: "auto",
      marginLeft: "10%",
    },
    logo: {
      textAlign: "center",
      width: "100px",
    },
    mobileView: {
      width: 392,
      flexGrow: 0,
      padding: "54px 40px 55px",
    },
    mobileLogoBox: {
      display: "flex",
      justifyContent: "start",
    },
    mobileLogo: {
      width: 65,
      height: 30,
      flexGrow: 0,
      padding: "0 0 1.4px",
    },
    signUp: {
      fontSize: 24,
      fontWeight: "bolder",
      color: "#161616",
      display: "flex",
      justifyContent: "left",
      marginTop: 40,
    },
    signInButton: {
      width: 311,
      height: 38,
      flexGrow: 0,
      padding: "10px 50px 10px 70px !important",
      marginTop: 24,
      borderRadius: "5px !important",
      boxShadow:
        " 0 2px 3px 0 rgba(0, 0, 0, 0.17), 0 0 3px 0 rgba(0, 0, 0, 0.08) !important",
      backgroundColor: "#FFF",
      "& div": {
        padding: "4px !important",
      },
      "& span": {
        padding: "0px !important",
        fontWeight: "800 !important",
        fontSize: "15px !important",
      },
    },
    form: {
      marginTop: 8,
    },
    mobileViewTextBox: {
      marginTop: 8,
      color: "#b8b8b8",
      height: 48,
    },
    eyeLogoBox: {
      height: 48,
      marginTop: 8,
    },
    registerSection: {
      display: "flex",
      flexDirection: "column",
      fontSize: 15,
      fontWeight: 600,
      marginTop: 25,
      textAlign: "left",
      "& a": {
        color: "#48b7a7 !important",
        fontWeight: "bold",
        marginLeft: 6,
      },
    },
    continueWithSection: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly",
      marginTop: 20,
      "& hr": {
        width: 95,
        border: "1px solid #A6AAB3",
      },
      "& span": {
        color: "#A6AAB3",
        margin: 5,
        fontWeight: "bold",
        fontSize: 12,
      },
    },
  })
);

export const Register: React.FC<RegisterProps> = ({}) => {
  const clientId =
    "381059260317-rl1qvckjoef2o5niim5h2um7nspakgv5.apps.googleusercontent.com";
  ReactGA.pageview(window.location.pathname);
  const eventTrackLogin = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };
  const history = useHistory();
  const classes = useStyles();
  const [name, setName] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [regIndex, setRegIndex] = useState(0);

  const [confirmpassword, setConfirmPassword] = useState("");

  const [passwordMsg, setPasswordMsg] = useState("");
  const [passwordIssue, setPasswordIssue] = useState(false);
  const [option, setOption] = useState(0);
  const [passwordInfo, setPasswordInfo] = useState(false);
  const [confirmPasswordInfo, setConfirmPasswordInfo] = useState(false);
  const [enableButton, setEnableButton] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [reqSat1, setReqSat1] = useState("invalid");
  const [reqSat2, setReqSat2] = useState("invalid");
  const [reqSat3, setReqSat3] = useState("invalid");
  const [reqSat4, setReqSat4] = useState("invalid");
  const [reqSat5, setReqSat5] = useState("invalid");
  const [loading, setLoading] = useState(false);
  const matches = useMediaQuery("(max-width:393px)");

  let regexp = new RegExp("(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,}");

  let regexp1 = new RegExp("(?=.*[a-z])");
  let regexp2 = new RegExp("(?=.*[A-Z])");
  let regexp3 = new RegExp("(?=.*[0-9])");

  useEffect(() => {}, [passwordIssue]);

  useEffect(() => {
    setEnableButton(
      firstname.length > 0 &&
        lastname.length > 0 &&
        email.length > 0 &&
        password.length > 6 &&
        regexp.test(password)
    );
  }, [firstname.length, lastname.length, email.length, password.length]);

  function validateForm() {
    return (
      firstname.length > 0 &&
      lastname.length > 0 &&
      email.length > 0 &&
      password.length > 6 &&
      password === confirmpassword &&
      regexp.test(password)
    );
  }
  function validateFormFormobile() {
    return (
      firstname.length > 0 &&
      lastname.length > 0 &&
      email.length > 0 &&
      password.length > 6 &&
      regexp.test(password)
    );
  }

  function validateP1() {
    return firstname.length > 0 && lastname.length > 0 && email.length > 0;
  }

  // function showPassReq() {
  //   if (passwordInfo) {
  //     console.log('not on password');
  //     setPasswordInfo(false);
  //   } else {
  //     setPasswordInfo(true);
  //   }
  // }

  function checkPass(password: string) {
    if (regexp1.test(password)) {
      setReqSat1("valid");
    } else {
      setReqSat1("invalid");
    }
    if (regexp2.test(password)) {
      setReqSat2("valid");
    } else {
      setReqSat2("invalid");
    }
    if (regexp3.test(password)) {
      setReqSat3("valid");
    } else {
      setReqSat3("invalid");
    }
    if (password.length >= 6) {
      setReqSat4("valid");
    } else {
      setReqSat4("invalid");
    }
  }

  function checkConfirmPass(confirmpassword: string) {
    if (password === confirmpassword) {
      setReqSat5("valid");
    } else {
      setReqSat5("invalid");
    }
  }

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (password != confirmpassword) {
      setPasswordIssue(true);
      setPasswordMsg("Passwords do not match");
      return false;
    }
    if (!regexp.test(password)) {
      setPasswordIssue(true);
      setPasswordMsg(
        "Minimum 6 characters: At least 1 lowercase, 1 uppercase, 1 number"
      );
      return false;
    } else {
      setPasswordIssue(false);
    }
    const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (regExpEmail.test(email)) {
      try {
        // // 'http://localhost:8080'
        // // const temp = await axios.post('http://localhost:8080' + '/signup', {
        // const temp = await axios.post(
        //   "https://sotira-back-test.herokuapp.com" + "/signup",
        //   {
        //     firstName: firstname,
        //     lastName: lastname,
        //     email: email, //'garykk1234@gmail.com',
        //     password: password, //'password123',

        //   }
        // );
        // // setToken(token);
        // //console.log('Registration succeeded');
        AuthService.register(firstname, lastname, email, password, 1)
          .then(() => {
            eventTrackLogin("Sign In", "Normal Sign In", "Button");
            setLoading(false);
            history.push("/onboarding");
          })
          .catch(() => {
            toast.error("An account with this email already exists.");
            setLoading(false);
          });
      } catch (e: any) {
        setLoading(false);
        alert(e.response.data);
      }
    } else {
      toast.error("Please type correct email");
      setLoading(false);
    }
  };

  const handleSubmitMobile = async (e) => {
    e.preventDefault();
    if (!regexp.test(password)) {
      setPasswordIssue(true);
      setPasswordMsg(
        "Minimum 6 characters: At least 1 lowercase, 1 uppercase, 1 number"
      );
      return false;
    } else {
      setPasswordIssue(false);
    }
    const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (regExpEmail.test(email)) {
      try {
        //'http://localhost:8080'
        //const temp = await axios.post('http://localhost:8080' + '/signup', {

        const temp = await axios.post(
          "https://sotira-back-test.herokuapp.com" + "/signup",
          {
            firstName: firstname,
            lastName: lastname,
            email: email, //'garykk1234@gmail.com',
            password: password, //'password123',
          }
        );
        //setToken(token);
        //console.log('Registration succeeded');
        history.push("/mobile");
      } catch (e: any) {
        alert(e.response.data);
      }
    } else {
      toast.error("Please type correct email");
    }
  };

  const responseGoogle = (response) => {
    const userInfo = response.profileObj;
    if (userInfo) {
      //console.log('info works');
      try {
        AuthService.loginGoogle(
          userInfo.email,
          userInfo.googleId,
          userInfo.givenName,
          userInfo.familyName,
          option
        ).then(() => {
          eventTrackLogin("Sign In", "Google Sign In", "Button");
          history.push("/");
        });
      } catch (e) {
        // alert(e.message);
      }
    }
  };

  const responseGoogleMobile = (response) => {
    const userInfo = response.profileObj;
    if (userInfo) {
      //console.log('info works');
      try {
        AuthService.loginGoogle(
          userInfo.email,
          userInfo.googleId,
          userInfo.givenName,
          userInfo.familyName,
          option
        ).then(() => {
          eventTrackLogin("Mobile Sign In", "Google Sign In", "Button");
          history.push("/");
        });
      } catch (e) {
        // alert(e.message);
      }
    }
  };

  return (
    <>
      {!matches ? (
        <div>
          <Container className="container">
            <Row className="row-auth">
              <div className="leftPanel">
                <div className={classes.logoBox}>
                  <a href="https://www.sotira.co/">
                    {" "}
                    <img alt="logo" className={classes.logo} src={larlogo} />
                  </a>
                </div>
                <div className="carousel">
                  <div className="Login">
                    <Carousel
                      pause="hover"
                      className="carousel-content"
                      bsPrefix="carousel"
                      indicators={false}
                      fade={true}
                      nextLabel={null}
                      prevLabel={null}
                      slide={true}
                    >
                      <Carousel.Item
                        className="carousel-item"
                        style={{ height: "525px" }}
                      >
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img1}
                          alt="First slide"
                        />
                        <div>
                          <Carousel.Caption className="mt-5">
                            <strong className="mt-5">
                              <h5 style={{ color: "black" }}>
                                One stop shop for all ecommerce transactions
                              </h5>
                            </strong>
                            <p style={{ color: "black" }}>
                              Say no to Excel spreadsheets
                            </p>
                            <p style={{ color: "black" }}>
                              Upload your excel sheets instantly to Sotira
                            </p>
                            <p style={{ color: "black" }}>
                              Synch your sales to automatically update in real
                              time on Sotira
                            </p>
                          </Carousel.Caption>
                        </div>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "540px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img2}
                          alt="Second slide"
                        />
                        <Carousel.Caption>
                          <h5 style={{ color: "black" }}>
                            Customized and personalized to the platforms you
                            sell on
                          </h5>
                          <p style={{ color: "black" }}>
                            Sotira is the most customizable ecommerce platform
                            to manage your online business as a seller or
                            reseller
                          </p>
                          <p style={{ color: "black" }}>
                            Financial templates and pricing tools are custom
                            filled with fees for ecommerce platforms
                          </p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "540px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img3}
                          alt="Third slide"
                        />
                        <Carousel.Caption>
                          <h5 style={{ color: "black" }}>Be more profitable</h5>
                          <p style={{ color: "black" }}>
                            Pick the right marketplace for the products you sell
                            - automatically compare projected profit across
                            multiple marketplaces
                          </p>
                          <p style={{ color: "black" }}>
                            See which products or product collections are top
                            selling
                          </p>
                          <p style={{ color: "black" }}>
                            Analyze profitability for your business(es)
                          </p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "450px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img4}
                          alt="Fourth slide"
                        />
                        <Carousel.Caption className="m-0">
                          <h5 style={{ color: "black" }}>
                            Pricing Discovery Calculators
                          </h5>
                          <p style={{ color: "black" }}>
                            Optimize your product prices and calculate profit,
                            profit margin, breakeven pricing and more.{" "}
                          </p>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>

              {/*Col for the right side */}
              <div
                className="rightPanel"
                style={{
                  backgroundColor: "white",
                  paddingBottom: "5%",
                }}
              >
                <div className="Login">
                  {/* <Header />  this is the register process */}
                  <Form onSubmit={handleSubmit}>
                    <div className="navStyle">
                      <NavBar></NavBar>
                    </div>
                    <h2 className="titleSign"> Sign Up </h2>
                    <Form.Group>
                      <GoogleLogin
                        clientId={clientId}
                        buttonText="Sign up with Google"
                        onSuccess={responseGoogle}
                        onFailure={responseGoogle}
                        cookiePolicy={"single_host_origin"}
                        className="google-login"
                      />
                    </Form.Group>
                    {regIndex == 0 && (
                      <div>
                        <Form.Group controlId="firstname">
                          <Form.Label className="title">First Name</Form.Label>
                          <Form.Control
                            autoFocus
                            type="firstname"
                            value={firstname}
                            placeholder="Enter first name"
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group controlId="lastname">
                          <Form.Label className="title">Last Name</Form.Label>
                          <Form.Control
                            type="lastname"
                            value={lastname}
                            placeholder="Enter last name"
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group controlId="email">
                          <Form.Label className="title">Email</Form.Label>
                          <Form.Control
                            type="email"
                            value={email}
                            placeholder="Enter email address"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </Form.Group>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 30,
                            textAlign: "center",
                          }}
                        >
                          <Button
                            className="login-button"
                            variant="primary"
                            onClick={() => setRegIndex(1)}
                            disabled={!validateP1()}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    )}
                    {regIndex == 1 && (
                      <div>
                        <Form.Group controlId="password">
                          <Form.Label>Password</Form.Label>

                          <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              checkPass(e.target.value);
                            }}
                            onClick={() => setPasswordInfo(true)}
                          />
                          {passwordInfo && (
                            <div>
                              <ul className="passwordReq">
                                <li className={reqSat1}> Lowercase letter </li>
                                <li className={reqSat2}>
                                  {" "}
                                  Capital (Uppercase) letter{" "}
                                </li>
                                <li className={reqSat3}> Number </li>
                                <li className={reqSat4}>
                                  {" "}
                                  Minimum 6 characters{" "}
                                </li>
                              </ul>
                            </div>
                          )}
                        </Form.Group>
                        <Form.Group controlId="confirmpassword">
                          <div className="d-flex justify-content-between">
                            <Form.Label className="confirm-password-label">
                              Confirm Password
                            </Form.Label>
                            {confirmPasswordInfo && (
                              <div>
                                <ul className="passwordReq">
                                  <li
                                    className={reqSat5}
                                    id="confirm-password-error"
                                  ></li>
                                </ul>
                              </div>
                            )}
                          </div>
                          <Form.Control
                            type="password"
                            value={confirmpassword}
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                              checkConfirmPass(e.target.value);
                            }}
                            onClick={() => setConfirmPasswordInfo(true)}
                          />
                        </Form.Group>
                        {passwordIssue && (
                          <div className="passworderror">
                            <p>{passwordMsg}</p>
                          </div>
                        )}

                        <Popup
                          trigger={<a className="refer-link">Refer a friend</a>}
                          modal
                          nested
                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="content">
                                <ReferFriendPop closeModal={close} />
                              </div>
                            </div>
                          )}
                        </Popup>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 30,
                            textAlign: "center",
                          }}
                        >
                          <Button
                            className="login-button"
                            variant="primary"
                            onClick={() => setRegIndex(0)}
                            size="sm"
                          >
                            Back
                          </Button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 30,
                            textAlign: "center",
                          }}
                        >
                          <Button
                            block
                            className="login-button"
                            variant="primary"
                            type="submit"
                            disabled={!validateForm()}
                          >
                            {loading ? (
                              <>
                                <CircularProgress className="file-loader mr-3" />{" "}
                                Sign Up{" "}
                              </>
                            ) : (
                              "Sign Up"
                            )}
                          </Button>
                        </div>
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 30,
                        fontWeight: "bold",
                        fontSize: 15,
                      }}
                    >
                      Already have an account?
                      <a style={{ color: "#89D0C6" }} href="/auth/login">
                        {" "}
                        &nbsp;Sign in here
                      </a>
                    </div>
                  </Form>
                </div>
              </div>
            </Row>
          </Container>
        </div>
      ) : (
        <MobileView className={classes.mobileView}>
          <div className={classes.mobileLogoBox}>
            <img alt="logo" className={classes.mobileLogo} src={larlogo} />
          </div>
          <div>
            <p className={classes.signUp}>Sign Up</p>
          </div>
          <GoogleLogin
            clientId={clientId}
            buttonText="Sign up with Google"
            onSuccess={responseGoogleMobile}
            onFailure={responseGoogleMobile}
            cookiePolicy={"single_host_origin"}
            className={classes.signInButton}
          />
          <div className={classes.continueWithSection}>
            <hr />
            <span>Or continue with</span>
            <hr />
          </div>
          <Form onSubmit={handleSubmitMobile} className={classes.form}>
            <Form.Group controlId="firstName">
              <Form.Label className="input-title">First Name</Form.Label>
              <Form.Control
                autoFocus
                autoComplete="on"
                type="text"
                placeholder="Enter first name"
                value={firstname}
                className={classes.mobileViewTextBox}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="lastName">
              <Form.Label className="input-title">Last Name</Form.Label>
              <Form.Control
                type="text"
                autoComplete="on"
                placeholder="Enter last name"
                value={lastname}
                className={classes.mobileViewTextBox}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label className="input-title">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email address"
                value={email}
                className={classes.mobileViewTextBox}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <InputGroup className="mb-3">
              <Form.Label className="input-title">Password</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                autoComplete="off"
                placeholder="Enter password"
                value={password}
                style={{ width: "250px" }}
                className={classes.mobileViewTextBox}
                onChange={(e) => {
                  setPassword(e.target.value);
                  checkPass(e.target.value);
                }}
                  onClick={() => setPasswordInfo(true)}
              />
              <InputGroup.Text className={classes.eyeLogoBox}>
                {showPassword ? (
                  <EyeSlashIcon
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                  />
                ) : (
                  <EyeIcon
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                  />
                )}
              </InputGroup.Text>
              {passwordInfo && (
                            <div>
                              <ul className="passwordReq">
                                <li className={reqSat1}> Lowercase letter </li>
                                <li className={reqSat2}>
                                  {" "}
                                  Capital (Uppercase) letter{" "}
                                </li>
                                <li className={reqSat3}> Number </li>
                                <li className={reqSat4}>
                                  {" "}
                                  Minimum 6 characters{" "}
                                </li>
                              </ul>
                            </div>
                          )}
            </InputGroup>
         
            <Popup
              trigger={<a className="refer-link">Refer a friend</a>}
              modal
              nested
              contentStyle={{minWidth:"285px"}}
            >
              {(close) => (
                <div className="mode">
                  <button className="close" onClick={close}>
                    &times;
                  </button>
                  <div className="content">
                    <ReferFriendPop closeModal={close} />
                  </div>
                </div>
              )}
            </Popup>

            <Button
              className="mobile-view-button"
              size="lg"
              type="submit"
              disabled={!validateFormFormobile()}
            >
              Sign Up
            </Button>
          </Form>
          <div className={classes.registerSection}>
            <span>
              Already have an account?<a href="/auth/login">Sign in here</a>
            </span>
          </div>
        </MobileView>
      )}
    </>
  );
};
